<template>
   <div style="margin: 1em; padding: 1em; border-radius: 5px; background: white;">
      <atom-title
         :title="type=='edit' ? 'Edit User' : 'Add User'"
         color='secondary'
      />
      <error-list :errors="errors.non_field"/>
      <form @submit.prevent="handleSubmit">
         <input-field
            label="First name"
            v-model="fields.first_name"
            :errors="errors.first_name"
            required
         />
         <input-field
            label="Last name"
            v-model="fields.last_name"
            :errors="errors.last_name"
            required
         />
         <input-field
            label="Phone No"
            v-model="fields.phone_no"
            :errors="errors.phone_no"
            required
         />
         <input-field
            label="Email"
            type="email"
            v-model="fields.email"
            :errors="errors.email"
            required
         />
         <input-field
            label="Role"
            type="select"
            :options="roleOptions"
            v-model="fields.role"
            :errors="errors.role"
            required
         />
         <input-field
            label="Is active"
            type="checkbox"
            v-model="fields.is_active"
            :errors="errors.is_active"
         />
         <input-field
            v-if="type==='create'"
            label="Password"
            type="password"
            v-model="fields.password"
            :errors="errors.password"
            required
         />
         <input-field
            v-if="type==='create'"
            label="Confirm password"
            type="password"
            v-model="fields.confirm_password"
            :errors="errors.confirm_password"
            required
         />
         <working-area-input
            :errors="errors.assigned_sddmms"
            :states="states"
            :selectMunicipality="selectMunicipality"
            :selectDistrict="selectDistrict"
            :selectState="selectState"
            :districtIsSelected="districtIsSelected"
            :stateIsSelected="stateIsSelected"
         />
         <submit-btn
            class="submit-btn"
            label="Submit"
            :isLoading="isSubmittingForm"
         />
      </form>
   </div>
</template>

<script>
import AtomTitle from '@/components/atoms/Login/Title';
import ErrorList from '@/components/molecules/Login/Errors';
import InputField from '@/components/molecules/Login/InputField';
import SubmitBtn from '@/components/molecules/Login/SubmitBtn';
import WorkingAreaInput from '@/components/organisms/Admin/Users/WorkingAreaInput';
import { mapActions,mapGetters } from 'vuex';
import { fetchWithAuthToken, postWithAuthToken } from '../../../../../axios';

const fieldNames = ["first_name", "last_name", "email", "role", "is_active", "phone_no", "password", "confirm_password", 'non_field'];

export default {
   name: 'user-form',
   components: {
      ErrorList,
      InputField,
      SubmitBtn,
      AtomTitle,
      WorkingAreaInput,
   },
   data()
   {
      const fields = {};
      const errors = {};
      fieldNames.forEach(name =>
      {
         fields[name] = "";
         errors[name] = [];
      });
      fields.is_active = false;
      return {
         fields,
         errors,
         formSubmitted: false,
         isSubmittingForm: false,
         states: []
      }
   },
   props: {
      type: {
         type: String,
         validator: val => ["create", "edit"].includes(val),
         default: "create"
      },
   },
   computed: {
      ...mapGetters('users', ['user']),
      assigned_sddmms() {
         return this.states.reduce((acc, state) =>
         {
            return state.districts.reduce((d_acc, district) => {
               return [
                  ...d_acc,
                  ...district.municipalities.filter(muni => muni.checked).map(muni => muni.sddmm)
               ];
            }, [...acc]);
         }, []);
      },
      roleOptions()
      {
         const adminRoles = [
            {title: 'Administrator', value: 1},
            {title: 'Manager',        value: 2},
         ];
         const managerRoles = [
            {title: 'Planner',        value: 3},
            {title: 'General',        value: 4},
         ];
         return (this.user && this.user.role==='Administrator') ?
            [...adminRoles, ...managerRoles]
            :
            managerRoles;
      },
      regionApiUrl() {
         const params = this.type==="edit" ? `?user_id=${this.$route.params.user_id}` : '';
         return `/api/layers/all-regions${params}` 
      },
      postApiUrl() {
         return `/api/users/${ this.type==='edit' ? this.$route.params.user_id : ''}`
      },
      postMethod() {
         return this.type === 'edit' ? "PUT" : "POST";
      },
   },
   created()
   {
      fetchWithAuthToken(this.regionApiUrl)
      .then(({data}) =>
      {
         this.states = data;
      });
      this.type==='edit' && fetchWithAuthToken(`/api/users/${this.$route.params.user_id}`)
      .then(({data}) => {
         this.fields=data;
         this.fields.role = data.role_id;
      });
   },
   methods: {
      ...mapActions('users', ['registerUser']),
      setErrors(errors)
      {
         fieldNames.forEach( field =>
         {
            this.errors[field] = errors[field] ? errors[field] : [];
         });
      },
      selectMunicipality(municipality, val)
      {
         municipality.checked = val;
      },
      districtIsSelected(district) {
         return district.municipalities.every(municipality => municipality.checked);
      },
      selectDistrict(district, val) {
         district.municipalities.forEach(municipality => {
            municipality.checked = val;
         });
      },
      selectState(state, val) {
         state.districts.forEach(district => this.selectDistrict(district, val));
      },
      stateIsSelected(state) {
         return state.districts.every(district => this.districtIsSelected(district));
      },
      async handleSubmit()
      {
         if (this.isSubmittingForm) return;
         try
         {
            this.isSubmittingForm = true;
            this.setErrors({}); // reset the errors
            const data = {...this.fields, assigned_sddmms: this.assigned_sddmms};
            const response = await postWithAuthToken(this.postApiUrl, data, {method: this.postMethod});
            const result = response.data;
            if (result.success)
            {
               this.formSubmitted = true;
               this.$router.push({name: 'user-list'});
            }
            else
            {
               this.setErrors(result.errors)
            }
         }
         catch (error)
         {
            console.log(error);
            this.errors.non_field = [error.message];
            if (!error.response)
            {
               this.errors.non_field = ["Couldn't connect to server. (Please check internet connection)"];
            }
            else {
               error.response.data && error.response.data.errors && this.setErrors(error.response.data.errors)
            }
         }
         this.isSubmittingForm = false;
      },
   },
}
</script>

<style lang="scss" scoped>
form {
   padding: 1em;
}
.submit-btn {
   margin: auto;
   display: block;
   width: 20ch;
}
</style>
